import { useMutation } from '@tanstack/react-query';
import { ocrFileService } from '../../../Domain/Connections/Services/Connection/OCR';
import type { DeleteOCRFileParams } from '../../../Domain/Connections/Services/Connection/OCR';

type DeleteOCRFile = DeleteOCRFileParams;

const mutationFn = (data: DeleteOCRFile) => {
  return ocrFileService.deleteOCRFile(data);
};

export const useConnectionDeleteOCRFileMutation = () => {
  return useMutation<unknown, unknown, DeleteOCRFile>(mutationFn);
};
